import ModalWrapper from '../../common/Modal/ModalWrapper'

const ReferCfoOfferModal = () => {
    return (
        <ModalWrapper
            modalType={'referCfoOffer'}
            modalCardClasses={'maw90'}
            customStyle={{
                padding: '0rem',
                overflow: 'hidden',
            }}
        >
            <div className='df w100'>
                <div className='pt2rem pb2rem pr2rem w70 pl4rem' style={{ backgroundColor: '#F5F7FF' }}>
                    <div className='df fdc aifs p2rem'>
                        <img src={require('../../../../images/referCfo/cfoCenterLogo.svg')} alt='referCfoOffer' style={{ maxWidth: '150px', width: '100%' }} />
                        <h2 style={{ color: '#F71873' }} className='c4 fs1rem mb0-5rem tal w100 tal'>Refer A Colleague CFO</h2>
                    </div>

                    <div className='p2rem'>
                        <h3 className='c4 fw400 mt2rem fs15px'>For each new CFO Centre fractional CFO you introduce to us*</h3>
                        <h3 className='fs2rem c15 fw500 mt0-5rem'>We will refund you 100% the first year Portfolio Pro subscription on your own first client</h3>

                        <h3 className='fs1rem c15 fw400 my0-5rem'>
                            - your CFO colleague will receive the same offer
                        </h3>

                        <p className='c49 fs1rem mt4rem mb2rem fw400'>
                            To get things rolling, please contact us or email this offer to your CFO colleague.
                        </p>

                        <div className='df aic jcfs'>
                            <button style={{ maxHeight: "40px" }} onClick={() => window.open('https://koalendar.com/e/meet-with-mark-bernstein', '_blank')} className='df jcsb px1rem new-shadow cp c1 bg4 fw400 fs1rem br38px w200px py0-5rem'>
                                <div className='df aic'>
                                    <img className='mr0-5rem' src={require('../../../../images/referCfo/telephone.svg')} alt='telephone' />
                                    <span className="pl0-5rem fw400 c1 fs14px" >
                                        Book a Call
                                    </span>
                                </div>
                                <img src={require('../../../../images/referCfo/right-arrows.svg')} alt='rightArrow' />
                            </button>
                            <a
                                className="df jcc new-shadow cp c1 bg3 fw400 fs14px br38px w200px py0-5rem ml1rem"
                                href={`mailto:?cc=mark.bernstein@diligentisia.co.uk&subject=Recommendation%20to%20use%20Diligentsia%20Platform&body=Dear%0D%0A%0D%0AFollowing%20the%20CFO%20Centre%E2%80%99s%207th%20October%20webinar%20introducing%20Diligentsia,%20I%E2%80%99ve%20started%20exploring%20their%20platform%20to%20streamline%20my%20CFO%20services%20and%20add%20value%20to%20clients.%20My%20advisor%20account%20is%20free,%20while%20clients%20can%20subscribe%20to%20Diligentsia%20Pro%20at%20%C2%A366/month%20(billed%20annually,%20%C2%A3799).%20They%20already%20have%20a%20number%20of%20CFOC%20CFOs/clients%20on%20the%20platform.%0D%0A%0D%0ATo%20encourage%20adoption,%20Diligentsia%20has%20launched%20a%20referral%20scheme:%0D%0A1.%20If%20you%20register%20your%20own%20account%20and%20then%20subscribe%20YOUR%20first%20client%20to%20Pro,%20MY%20first%20client%E2%80%99s%20subscription%20will%20be%20refunded%20(giving%20them%20their%20first%20year%20free).%0D%0A2.%20Likewise,%20if%20you%20subsequently%20refer%20Diligentsia%E2%80%99s%20platform%20to%20another%20new%20colleague,%20your%20first%20client%20will%20also%20be%20similarly%20reimbursed.%0D%0A3.%20Their%20website%20is%20www.diligentsia.co.uk/fractionalCFO%0D%0A%0D%0AIf%20you%E2%80%99d%20like%20to%20explore%20how%20Diligentsia%20can%20help%20you%20and%20your%20clients,%20book%20a%20call%20with%20CEO%20Mark%20Bernstein%20ACA:%0D%0A%0D%0AMeet%20with%20Mark%20Bernstein%20%7C%20Koalendar%20-%20https://koalendar.com/e/meet-with-mark-bernstein%0D%0A%0D%0ALet%20me%20know%20how%20you%20get%20on!%0D%0A%0D%0ABest,`}
                            >
                                Invite by Email
                            </a>


                        </div>

                        <p className='c49 fs11px mt2rem'>*= who signs up one of their own existing CFO Centre clients by end of October 2025</p>

                    </div>
                </div>

                <div
                    className='w30 pt1rem'
                    style={{ backgroundImage: "linear-gradient(to right, #B9D9F9, #7FBDFA)" }}
                >
                    <div
                        className='br8px p2rem df aic jcc fdc w80 mxa'
                        style={{ backgroundImage: "linear-gradient(to right, #FFFFFF33, #ffffff39)" }}
                    >

                        <div className='mb0-5rem df fdc aic jcc'>
                            <img className="mb0-5rem" style={{ width: '32px', height: '32px' }} src={require("../../../../images/referCfo/refer.png")} alt="cfoCenterRefer" />
                            <h3 className='c15 fs14px'>Refer</h3>
                            <p className='c49 fs11px tac'> Refer a new CFO Centre fractional <br></br> CFO colleague to us* </p>
                        </div>

                        <div className='mb0-5rem df fdc aic jcc'>
                            <img className="mb0-5rem" style={{ width: '32px', height: '32px' }} src={require("../../../../images/referCfo/fraction.png")} alt="cfoCenterFraction" />
                            <h3 className='c15 fs14px'>Fractional CFO Joins</h3>
                            <p className='c49 fs11px tac'>The CFO joins our platform and on-boards THEIR first <br></br> CFO Centre client on a Portfolio Pro subscription​</p>
                        </div>

                        <div className='mb0-5rem df fdc aic jcc'>
                            <img className="mb0-5rem" style={{ width: '32px', height: '32px' }} src={require("../../../../images/referCfo/refund.png")} alt="cfoCenterRefund" />
                            <h3 className='c15 fs14px'>100% Refund</h3>
                            <p className='c49 fs11px tac'>We will refund 100% of the Portfolio Pro subscription you or your client paid on their first year subscription </p>
                            <p className='c49 fs11px tac mt1rem'>Your referral can a repeat the process for their own<br></br> CFO Centre colleagues</p>
                        </div>

                    </div>

                    <ul>
                        <li className='c49 fs10px tac w80 mxa mt0-5rem op90' style={{ listStyleType: 'disc' }}>can’t be used in conjunction with any other discount or offer. If you subscribe on behalf of your client, we will promptly reimburse you</li>
                    </ul>

                    <div className='w100'>
                        <img className='w100' src={require('../../../../images/referCfo/referOfferRightIcon.png')} alt="referOfferRightIcon" />
                    </div>

                </div>
            </div>


        </ModalWrapper>
    )
}

export default ReferCfoOfferModal